import { create } from "zustand";

interface SelectionStore {
  selectedEmailId: string | null;
  open: (id: string) => void;
  close: () => void;
}

export const useSelectionStore = create<SelectionStore>((set) => ({
  selectedEmailId: null,
  open: (id) => set({ selectedEmailId: id }),
  close: () => set({ selectedEmailId: null }),
}));
